import { createSlice } from "@reduxjs/toolkit";
import { apiCaller } from "../../api/apiCaller";
import { playerapi, kycApi } from "../../sharedfiles/EndpointConfig";
import { toaster } from "../../sharedfiles/helper";

export const kycuserSlice = createSlice({
    name: "kycusers",
    initialState: {
        kycUserData: [],
        paginationFirstValue: 1,
        paginationSecondValue: 25,
        recordsShow: [1, 25],
        isVisible: false,
    },
    reducers: {
        setKycUserData: (state, action) => {
            state.kycUserData = action.payload;
        },
        setPaginationFirstValue: (state, action) => {
            state.paginationFirstValue = action.payload;
        },
        setPaginationSecondValue: (state, action) => {
            state.paginationSecondValue = action.payload;
        },
        setRecordsShow: (state, action) => {
            state.recordsShow = action.payload;
        },
        setIsVisible: (state, action) => {
            state.isVisible = action.payload;
        },
    },
});

export const {
    setKycUserData,
    setPaginationFirstValue,
    setPaginationSecondValue,
    setRecordsShow,
    setIsVisible
} = kycuserSlice.actions;

export const getKycUserList = (itemsPerPage, pageNum, params) => (dispatch, getState) => {
    const existingData = getState().kycusers.kycUserData;

    // If data already exists in Redux, no need to refetch
    if (existingData && existingData.length > 0) {
        return;
    }

    const arr = [];
    for (let key in params) {
        if (params[key] !== "" && params[key] !== null && params[key] !== undefined) {
            arr.push(params[key]);
        }
    }

    const isTrue = arr.length >= 2;
    const pageNumber = isTrue ? 0 : itemsPerPage;
    const url = `${playerapi.getPlayerSearch}` +
        "?itemsPerPage=" +
        pageNum +
        "&pageNumber=" +
        pageNumber;

    apiCaller(url, "POST", params)
        .then((res) => {
            if (res && res.data) {
                dispatch(setKycUserData(res.data));
                localStorage.setItem("kycUserData", JSON.stringify(res.data)); // Caching in localStorage
                dispatch(setIsVisible(true));
            }
        })
        .catch(() => {
            dispatch(setKycUserData([]));
            dispatch(setIsVisible(false));
        });
};

export const kycApprovalAll = (status, id) => (dispatch) => {
    const url = kycApi.getKycApproval;
    const data = {
        status: status,
        userId: id,
    };
    apiCaller(url, "POST", data)
        .then((res) => {
            if (res.status === 200) {
                toaster.success("SUCCESS");
                dispatch(getKycUserList(0, 25, { kycStatus: "SUBMITTED" }));
            } else {
                toaster.error("FAILED");
            }
        })
        .catch(() => toaster.error("FAILED"));
};

export const kycRejectAll = (status, id, comments) => (dispatch) => {
    const url = kycApi.getkycRejected;
    const data = {
        status: status,
        userId: id,
        comments: comments,
    };
    apiCaller(url, "POST", data)
        .then((res) => {
            if (res.status === 200) {
                toaster.success("SUCCESS");
                dispatch(getKycUserList(0, 25, { kycStatus: "SUBMITTED" }));
            } else {
                toaster.error("FAILED");
            }
        })
        .catch(() => toaster.error("FAILED"));
};

export default kycuserSlice.reducer;
